export const CHICRUITING_LANDING_PATH = "/chicruiting/company/mypage";
